export default __webpack_public_path__ + "static/media/livestream1.d5ec1487.png";